import React from "react";
import {Provider} from "mobx-react";
import {observable} from "mobx";
import SelectionContext from "../contexts/SelectionContext";
import {CollectionContext} from "../collections";
import {getMapValue} from "@morningtrain/react-helpers";

export default class Selection extends React.Component {

    static contextType = CollectionContext;

    @observable selected = new Set();

    constructor (props) {
        super(props)

        this.all_globally_selected = observable.box(false)
    }

    get isGlobalAllSelectedSupported() {
        return this.props.globalSelectAll === true
    }

    get isAllGloballySelected() {
        return this.all_globally_selected.get() === true
    }

    get collection() {
        return this.context;
    }

    get modelKeyName() {
        return this.props.modelKeyName || 'id';
    }

    get selectedItems() {
        if(!this.collection) {
            return [];
        }

        return this.collection.filter(entry => this.isItemSelected(entry))
    }

    isItemSelected(entry, modelKeyName = 'id') {
        return this.isSelected(getMapValue(entry, this.modelKeyName || modelKeyName))
    }

    isSelected(modelKey) {
        if(this.isGlobalAllSelectedSupported && this.isAllGloballySelected) {
            return true
        }

        return this.selected.has(modelKey + '');
    }

    pluck(key) {
        return this.selectedItems.map(entry => getMapValue(entry, key))
    }

    allSelected(modelKeyName = 'id') {
        if(this.isGlobalAllSelectedSupported) {
            return this.isAllGloballySelected
        }

        if (this.collection.length < 1) return false;

        return this.collection.every(e => this.isItemSelected(e, modelKeyName));
    }

    getSelected = () => {
        return Array.from(this.selected);
    }

    isEmpty() {
        return this.length === 0;
    }

    isNotEmpty() {
        return this.length > 0;
    }

    get length() {
        return this.getSelected().length;
    }

    clearSelected = () => {
        this.selected.clear();
        this.all_globally_selected.set(false)
    }

    toggleAll(bol, modelKeyName = 'id') {
        if(this.isGlobalAllSelectedSupported) {
            this.all_globally_selected.set(bol)
        } else {
            this.collection.forEach(e => this._toggleSelected(getMapValue(e, this.modelKeyName || modelKeyName), bol));
        }
    }

    toggleSingle(id, bol) {
        this._toggleSelected((id+''), bol);
        this.all_globally_selected.set(false)
    }

    _toggleSelected(id, is_selected) {
        is_selected ?
            this.add(id) :
            this.delete(id);
    }

    add(id) {
        this.selected.add(id + '');
        this.all_globally_selected.set(false)
    }

    delete(id) {
        return this.selected.delete(id + '');
        this.all_globally_selected.set(false)
    }

    render() {
        return (
            <Provider selection={this}>
                <SelectionContext.Provider value={this} >
                    <React.Fragment>
                        {this.props.children}
                    </React.Fragment>
                </SelectionContext.Provider>
            </Provider>
        );
    }

}
